<template>
    <div>
        <section id="home" class="hero-component pt-5">

            <div class="container">
                <img class="d-none d-lg-block" src="../../assets/img/home/art-kids.png" alt="Four sketches of a young child participating in various activities throughout their day">
                <img class="d-block d-lg-none w-100" src="../../assets/img/home/art-kids-m.png" alt="Four sketches of a young child participating in various activities throughout their day">

                <div class="container content-transform">
                    <div class="content title-container">
                        <h1 class="gtitle text-center fw-semibold">Make JORNAY PM your <br class="d-block d-lg-none" /> first-choice long-acting
                            methylphenidate<sup class="omnes">1,2</sup></h1>
                    </div>
                </div>


            </div>
        </section>
    </div>
</template>
<script>

export default {


}
</script>